<template>
  <div>
    <common-dialog ref="dialog" width="1400px" title="质检" id-key="ReportId" :data="data" @closed="onClosed" @edit-opened="openEditOpened" :showSaveButton="false">
      <!-- :get-data-func="api.info" -->
      <template slot="form">
        <div class="row-tb-head">
          <div class="flex">
            <div class="mrx36 flex">
              <div style="min-width: 75px">工单编码</div>
              <el-input v-model="workNo" placeholder="输入工单编码" @change="chooseSets"></el-input>
            </div>
            <span style="margin-right: 80px">可以扫码或者输入后自动回车显示到下面表格</span>
            <div class="mrx36">
              <span class="inline_block">质检人：</span>
              <span class="inline_block">{{ data.Dts.length > 0 ? operator : '' }}</span>
            </div>
            <div class="mrx36 flex">
              <div style="min-width: 75px">检验日期</div>
              <el-date-picker v-model="testDate" type="date" placeholder="选择日期"> </el-date-picker>
            </div>
          </div>
        </div>
        <template v-if="displayMode === 1">
          <el-table class="table-line tb-c-head" :data="data.Dts" border>
            <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
            <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
            <el-table-column label="模具编号" prop="MouldNo" min-width="120" show-overflow-tooltip />
            <el-table-column label="模具名称" prop="MouldName" min-width="120" />
            <el-table-column label="模数" prop="Quantity" min-width="70" />
            <el-table-column label="排产模数" prop="ThisPlanQuantity" width="80" />
            <el-table-column label="一出几" prop="Afew" width="80" />
            <el-table-column label="待质检模数" prop="ThisPlanQuantity" width="100"></el-table-column>
          </el-table>
          <div class="border" style="margin-top: 10px; padding-top: 8px">
            <div class="app-container" style="padding: 10px 10px 0 10px">
              <el-form :inline="true" :model="formInline" class="form-item" label-width="140px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="本次合格模数"> <el-input style="width:140px" v-model="formInline.PassQuantity" placeholder="请输入本次合格模数"></el-input> </el-form-item
                  ></el-col>                  
                  <!-- <el-col :span="6">
                    <el-form-item label="本次合格数量(个)"> <el-input style="width:140px" v-model="formInline.PassQuantity3" placeholder="请输入本次合格数量(个)" @change="changePassQuantity3"></el-input> </el-form-item
                  ></el-col> -->
                  <el-col :span="6">
                    <el-form-item label="本次合格克重"> <el-input style="width:140px" v-model="formInline.PassGrammage" placeholder="请输入本次克重" @change="changeMouldPassGrammage"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="6">
                    <el-form-item label="本次合格数量(kg)"> <el-input style="width:140px" v-model="formInline.PassQuantity2" placeholder="请输入本次合格数量" @change="changePassQuantity2"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="6">
                    <el-form-item label="本次不合格模数"> <el-input style="width:140px" v-model="formInline.FailQuantity" placeholder="请输入本次不合格模数"></el-input> </el-form-item
                  ></el-col>
                  <!-- <el-col :span="6">
                    <el-form-item label="本次不合格数量(个)"> <el-input style="width:140px" v-model="formInline.FailQuantity3" placeholder="请输入本次不合格数量(个)"></el-input> </el-form-item
                  ></el-col> -->
                  <el-col :span="6">
                    <el-form-item label="本次不合格克重"> <el-input style="width:140px" v-model="formInline.FailGrammage" placeholder="请输入本次不合格克重" @change="changeMouldFailGrammage"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="6">
                    <el-form-item label="本次不合格数量(kg)">
                      <el-input  style="width:140px" v-model="formInline.FailQuantity2" placeholder="请输入本次不合格数量(kg)" @change="changeFailQuantity2"></el-input> </el-form-item
                  ></el-col>

                  <el-col :span="24">
                    <el-form-item label="质检情况"> <el-input v-model="formInline.Remark" placeholder="请输入本次质检情况" style="width: 620px"></el-input> </el-form-item
                  ></el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </template>

        <template v-if="displayMode === 2">
          <el-table class="table-line tb-c-head" :data="data.Dts" border>
            <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
            <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
            <el-table-column label="存货编号" prop="ProductNo" min-width="120" show-overflow-tooltip />
            <el-table-column label="存货名称" prop="ProductName" min-width="120" />
            <el-table-column label="生产数量" prop="Quantity" min-width="70" />
            <el-table-column label="排产数量" prop="ThisPlanQuantity" width="80" />
            <el-table-column label="待质检数量" prop="ThisPlanQuantity" width="90" />
          </el-table>
          <div class="border" style="margin-top: 10px; padding-top: 8px">
            <div class="app-container" style="padding: 10px 10px 0 10px">
              <el-form :inline="true" :model="formInline" class="form-item" label-width="150px">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="本次合格数量(个)"> <el-input v-model="formInline.PassQuantity" placeholder="请输入本次合格数量(个)"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="8">
                    <el-form-item label="本次合格克重"> <el-input v-model="formInline.PassGrammage" placeholder="请输入本次克重" @change="changeProductPassGrammage"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="8">
                    <el-form-item label="本次合格数量(kg)">
                      <el-input v-model="formInline.PassQuantity2" placeholder="请输入本次合格数量(kg)" @change="changeProductPassQuantity2"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="8">
                    <el-form-item label="本次不合格数量(个)"> <el-input v-model="formInline.FailQuantity" placeholder="请输入本次不合格数量(个)"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="8">
                    <el-form-item label="本次不合格克重"> <el-input v-model="formInline.FailGrammage" placeholder="请输入本次不合格克重" @change="changeProductFailGrammage"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="8">
                    <el-form-item label="本次不合格数量(kg)">
                      <el-input v-model="formInline.FailQuantity2" placeholder="请输入本次不合格数量(kg)" @change="changeProductFailQuantity2"></el-input> </el-form-item
                  ></el-col>

                  <el-col :span="24">
                    <el-form-item label="质检情况"> <el-input v-model="formInline.Remark" placeholder="请输入本次质检情况" style="width: 620px"></el-input> </el-form-item
                  ></el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </template>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    displayMode: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      api: require('@/api/pr/test').default,
      // api: require("@/api/sy/user").default,
      workNo: '',
      testDate: this.$commonJs.getToday(),
      data: {
        ReportId: 0,
        PlanId: null,
        Stage: 0,
        StartDate: null,
        EndDate: null,
        ProcessName: '',
        ReportDate: null,
        Dts: [],
        Materials: [],
        Products: [],
        operator: ''
      },
      formInline: {
        PassQuantity: null,
        FailQuantity: null,
        Remark: null,
        PassGrammage: null,
        FailQuantity: null,
        FailGrammage: null,
        FailQuantity2: null
      }
    }
  },
  computed: {},
  methods: {
    changePassQuantity3(val){
      // if(val>0){
      //   if(this.formInline.PassGrammage>0){
      //     this.formInline.PassQuantity2=Number((val/this.formInline.PassGrammage*1000).toFixed(4))
      //     this.formInline.PassQuantity=parseInt(val/this.data.Dts[0].Afew);
      //      if (this.formInline.PassQuantity > this.data.Dts[0].ThisPlanQuantity) {
      //       this.formInline.FailQuantity = 0
      //       this.formInline.FailQuantity3 = 0;
      //       this.$message.warning('本次合格模数超过待质检模数')
      //     }
      //     var failQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.PassQuantity
      //     if (failQuantity >= 0) {
      //       this.formInline.FailQuantity = failQuantity
      //       this.formInline.FailQuantity3 = failQuantity* this.data.Dts[0].Afew
      //     }
      //   }
      // }else{        
      //   this.formInline.PassQuantity = 0
      //   this.formInline.PassQuantity2 = 0
      // }
    },
    changeMouldPassGrammage(val) {
      console.log(val, 'aa')
      if (val > 0) {
        if (this.formInline.PassQuantity2) {
          var quantity = (this.formInline.PassQuantity2 * 1000) / val
          this.formInline.PassQuantity = parseInt(quantity / this.data.Dts[0].Afew)
          //this.formInline.PassQuantity3=parseInt(quantity* this.data.Dts[0].Afew);
          if (this.formInline.PassQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.FailQuantity = 0
            //this.formInline.FailQuantity3 = 0;
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var failQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.PassQuantity
          if (failQuantity >= 0) {
            this.formInline.FailQuantity = failQuantity
            //this.formInline.FailQuantity3 = failQuantity* this.data.Dts[0].Afew
          }
        }
      } else {
        this.formInline.PassQuantity = 0
        //this.formInline.PassQuantity3 = 0
        
      }
    },
    changePassQuantity2(val) {
      if (val) {
        if (this.formInline.PassGrammage > 0) {
          var quantity = (val * 1000) / this.formInline.PassGrammage
          this.formInline.PassQuantity = parseInt(quantity / this.data.Dts[0].Afew)
          //this.formInline.PassQuantity3 = parseInt(quantity* this.data.Dts[0].Afew);
          if (this.formInline.PassQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.FailQuantity = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var failQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.PassQuantity
          if (failQuantity >= 0) {
            this.formInline.FailQuantity = failQuantity
          }
        } else {
          this.formInline.PassQuantity = 0
          //this.formInline.PassQuantity3 = 0
        }
      } else {
        this.formInline.PassQuantity = 0
        //this.formInline.PassQuantity3 = 0
      }
    },

    changeMouldFailGrammage(val) {
      console.log(val, 'aa')
      if (val > 0) {
        if (this.formInline.FailQuantity2) {
          var quantity = (this.formInline.FailQuantity2 * 1000) / val
          this.formInline.FailQuantity = parseInt(quantity / this.data.Dts[0].Afew)
          //this.formInline.FailQuantity3 = parseInt(quantity* this.data.Dts[0].Afew)
          if (this.formInline.FailQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.PassQuantity = 0
            //this.formInline.PassQuantity3 = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var passQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.FailQuantity
          if (passQuantity >= 0) {
            this.formInline.PassQuantity = passQuantity
            //this.formInline.PassQuantity3 = passQuantity*this.data.Dts[0].Afew
          }
        }
      } else {
        this.formInline.FailQuantity = 0
        //this.formInline.FailQuantity3 = 0
      }
    },
    changeFailQuantity2(val) {
      if (val) {
        if (this.formInline.FailGrammage > 0) {
          var quantity = (val * 1000) / this.formInline.FailGrammage
          this.formInline.FailQuantity = parseInt(quantity / this.data.Dts[0].Afew)
          //this.formInline.FailQuantity3 = parseInt(quantity* this.data.Dts[0].Afew)
          if (this.formInline.FailQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.PassQuantity = 0
            //this.formInline.PassQuantity3 = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var passQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.FailQuantity
          if (passQuantity >= 0) {
            this.formInline.PassQuantity = passQuantity
            //this.formInline.PassQuantity3 = passQuantity*this.data.Dts[0].Afew
          }
        } else {
          this.formInline.FailQuantity = 0
          //this.formInline.FailQuantity3 = 0
        }
      } else {
          this.formInline.FailQuantity = 0
          //this.formInline.FailQuantity3 = 0
      }
    },
    changeProductPassGrammage(val) {
      console.log(val, 'aa')
      if (val > 0) {
        if (this.formInline.PassQuantity2) {
          var quantity = (this.formInline.PassQuantity2 * 1000) / val
          this.formInline.PassQuantity = parseInt(quantity)
          if (this.formInline.PassQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.FailQuantity = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var failQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.PassQuantity
          if (failQuantity >= 0) {
            this.formInline.FailQuantity = failQuantity
          }
        }
      } else {
        this.formInline.PassQuantity = 0
      }
    },
    changeProductPassQuantity2(val) {
      if (val) {
        if (this.formInline.PassGrammage > 0) {
          var quantity = (val * 1000) / this.formInline.PassGrammage
          this.formInline.PassQuantity = parseInt(quantity)
          if (this.formInline.PassQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.FailQuantity = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var failQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.PassQuantity
          if (failQuantity >= 0) {
            this.formInline.FailQuantity = failQuantity
          }
        }
      } else {
        this.formInline.PassQuantity = 0
      }
    },

    changeProductFailGrammage(val) {
      console.log(val, 'aa')
      if (val > 0) {
        if (this.formInline.FailQuantity2) {
          var quantity = (this.formInline.FailQuantity2 * 1000) / val
          this.formInline.FailQuantity = parseInt(quantity)
          if (this.formInline.FailQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.PassQuantity = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var passQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.FailQuantity
          if (passQuantity >= 0) {
            this.formInline.PassQuantity = passQuantity
          }
        }
      } else {
        this.formInline.FailQuantity = 0
      }
    },
    changeProductFailQuantity2(val) {
      if (val) {
        if (this.formInline.FailGrammage > 0) {
          var quantity = (val * 1000) / this.formInline.FailGrammage
          this.formInline.FailQuantity = parseInt(quantity)
          if (this.formInline.FailQuantity > this.data.Dts[0].ThisPlanQuantity) {
            this.formInline.PassQuantity = 0
            this.$message.warning('本次合格模数超过待质检模数')
          }
          var passQuantity = this.data.Dts[0].ThisPlanQuantity - this.formInline.FailQuantity
          if (passQuantity >= 0) {
            this.formInline.PassQuantity = passQuantity
          }
        }
      } else {
        this.formInline.FailQuantity = 0
      }
    },
    chooseSets(data) {
      this.api
        .getWorkDocProductTestList({
          WorkDocNo: data
        })
        .then(res => {
          this.data.Dts = []
          if (res.Data && res.Data.length > 0) {
            res.Data.forEach(item => {
              this.data.Dts.push(item)
            })
          } else {
            this.$message.warning('暂无数据！')
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    onClosed() {
      this.data.Dts = []
      this.data.Materials = []
      this.data.Products = []
      this.workNo = ''
      this.testDate = this.$commonJs.getToday()
    },
    close() {
      this.$refs.dialog.close()
    },
    async openEditOpened(data) {
      console.log(data, 'reportData')
      this.operator = JSON.parse(localStorage.getItem('loginInfo')).UserName
      let o = {}
      let infoData = []
      if (data.batch) {
        const ids = data.checkList.map(item => item.WorkDocId)
        o = { WorkDocIds: ids }
      } else {
        o = {
          WorkDocId: data.row.WorkDocId,
          WorkDocNo: data.row.WorkDocNo,
          PlanDtsId: data.row.PlanDtsId
        }
      }
      const res = await this.api.getWorkDocProductTestList(o)
      if (!res.IsSucc) return this.$message.error(res.Msg)
      if (res.Data && res.Data.length > 0) {
        infoData = res.Data
      }
      // this.edit({infoData: this.$refs.toCheckList.workInfo, batch: true})
      this.data.Dts = infoData.map(item => {
        return {
          ...item,
          ThisReportQuantityNumber2: 0,
          PlanDtsId: data.row.PlanDtsId
        }
      })
      this.data.batch = data.batch
    },
    async onSubmit() {
      let isReturn = false
      if (this.formInline.PassQuantity == null || this.formInline.PassQuantity == undefined) {
        this.$message.error('请输入本次合格数量')
        isReturn = true
        return
      }
      if (this.formInline.PassQuantity2 == null || this.formInline.PassQuantity2 == undefined) {
        this.$message.error('请输入本次合格数量(kg)')
        isReturn = true
        return
      }
      if (this.formInline.FailQuantity == null || this.formInline.FailQuantity == undefined) {
        this.$message.error('请输入本次不合格数量')
        isReturn = true
        return
      }
      var arr = [{ WorkDocId: this.data.Dts[0].WorkDocId, PlanDtsId: this.data.Dts[0].PlanDtsId, ...this.formInline }]
      // const arr = this.data.Dts.map(item => {
      //   if (item.UnTestQuantity == null || item.UnTestQuantity == undefined) {
      //     this.$message.error('请输入本次合格数量')
      //     isReturn = true
      //     return
      //   }
      //   if (item.ThisReportQuantityNumber2 == null || item.ThisReportQuantityNumber2 == undefined) {
      //     console.log(item.ThisReportQuantityNumber2)
      //     this.$message.error('请输入本次不合格数量')
      //     isReturn = true
      //     return
      //   }
      //   return {
      //     WorkDocId: item.WorkDocId,
      //     PassQuantity: Number(item.UnTestQuantity),
      //     FailQuantity: Number(item.ThisReportQuantityNumber2),
      //     // PassQuantity2: Number(item.UnTestQuantity2),
      //     // FailQuantity2: Number(item.ThisReportQuantityNumber2),
      //     Remark: item.Remark,
      //     PlanDtsId: item.PlanDtsId
      //   }
      // })
      if (isReturn) return
      if (this.testDate == '') return this.$message.warning('请输入检验日期')
      const res = await this.api.submit({ TestSaves: arr, TestDate: this.$dayjs(this.testDate).format('YYYY-MM-DD') })
      if (!res.IsSucc) return this.$message.error(res.Msg)
      this.$message.success('保存成功！')
      this.$refs.dialog.isChange = false
      this.close()
      this.$emit('saved')
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.inline_block {
  display: inline-block;
}
.mrx36 {
  margin-right: 36px;
}
</style>